export default __webpack_public_path__ + "media/background-mobile.4fc55ca8b903abafedabcb62d017ce51.webp";